module.exports = __webpack_public_path__ + "img/btn2.4bf6d724.png";